import React from 'react';

const SvgErrorIcon = props => (
  <svg
    data-name="ic_error"
    width={props.size || 80.197}
    height={props.size || 80.197}
    viewBox="0 0 80.197 80.197"
    fill="#fe685e"
    {...props}
  >
    <g id="alert_danger_svg___002-alert" data-name="002-alert">
      <path
        id="alert_danger_svg__Path_207"
        d="M40.1 0a40.1 40.1 0 1040.1 40.1A40.144 40.144 0 0040.1 0zm0 77.112A37.014 37.014 0 1177.112 40.1 37.057 37.057 0 0140.1 77.112z"
        className="alert_danger_svg__cls-1"
        data-name="Path 207"
      />
      <path
        id="alert_danger_svg__Path_375"
        d="M1.674 0A1.673 1.673 0 000 1.674V38.5a1.674 1.674 0 103.348 0V1.674A1.673 1.673 0 001.674 0z"
        className="alert_danger_svg__cls-1"
        data-name="Path 375"
        transform="rotate(90 10.957 49.229)"
      />
    </g>
  </svg>
);

export default SvgErrorIcon;
